import { SDK } from "@sdk";

import { iScreenTour } from "@sdk/screen-tours/screen-tours-model";
import { Store } from "redux";
import { QueryConfig } from "store/utils/query-config";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { screenToursDefaultQueryConfig } from "./screen-tours-default-query";
import { ScreenToursSlice } from "./screen-tours.slice";

export const loadAllScreenTours =
  () => async (store: Store<iStore>, forceReload?: boolean) => {
    await loadScreenToursQuery(screenToursDefaultQueryConfig, "all")(
      store,
      forceReload,
    );
  };

export const loadQueryScreenTours =
  (queryConfig: QueryConfig, queryAlias?: string) =>
  async (store: Store<iStore>, forceReload?: boolean) => {
    queryAlias = queryAlias || JSON.stringify(queryConfig);
    await loadScreenToursQuery(queryConfig, queryAlias)(store, forceReload);
  };

export const {
  loadEntityQueries: loadScreenToursQuery,
  loadEntityById: loadScreenTourById,
  loadMoreEntityQueries: loadMoreScreenToursQueries,
} = CreateHelpersForEntity<iStore, iScreenTour>({
  sliceName: "screenTours",
  slice: ScreenToursSlice,
  isPaginatedQueries: true,
  fetchPageSize: 50,
  loadEntityQueryProvider: (query) => SDK.screenTours.query(query),
  loadEntityByIdProvider: (entityId: string) =>
    SDK.screenTours.getById(entityId),
});
